export const EngineNames = {
    TopicGroupEngine: 'TopicGroupEngine',
    GroupNodeEngine: 'GroupNodeEngine',
    SearchEngine: 'SearchEngine',
    SearchQueryEngine: 'SearchQueryEngine', // ADDED
    YourDataEngine: 'YourDataEngine',
    TemplateEngine: 'TemplateEngine',
    LogEngine: 'LogEngine', // ADDED
    NoteOptionsPanelEngine: 'NoteOptionsPanelEngine', // ADDED
    FormConfigEngine: 'FormConfigEngine',
    CsCodeGenConfigEngine: 'CsCodeGenConfigEngine', // ADDED
    CsCodeTemplateEngine: 'CsCodeTemplateEngine', // ADDED
    DeleteConfirmEngine: 'DeleteConfirmEngine', // ADDED 20260704 — generic delete-confirm flow
    UmlNotesEngine: 'UmlNotesEngine', // Uml Notes loader engine, holds all Uml canvas notes
    UmlPreviewEngine: 'UmlPreviewEngine', // Uml schema preview-note cache, keyed by schema rk
    UmlPkgLibEngine: 'UmlPkgLibEngine', // Uml package-template library, holds all UmlPkgLib notes
    UmlPkgSaveDlg: 'UmlPkgSaveDlg', // Copy-Package dialog open-request channel (C-hotkey + toolbar button), see UmlPkgSaveDlg.jsx
    UserStateEngine2: 'UserStateEngine2',
};
